<template>
	<div>
		<ListHeaderComponent :background="background">
			<span slot="title">{{title}}</span>
		</ListHeaderComponent>
		<FiltersComponents></FiltersComponents>
		<EventsComponent></EventsComponent>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	import ListHeaderComponent from '@/components/ListHeaderComponent'
	import FiltersComponents from '@/components/MyEventsList/FiltersComponents'
	import EventsComponent from '@/components/MyEventsList/EventsComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'

	export default {
		components: {
			ListHeaderComponent,
			FiltersComponents,
			EventsComponent,
			ContactComponent,
			PartnersComponent
		},
		data () {
			return {
				title: this.$t('events.myEvents'),
				background: 'events'
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/MyEventsList.vue